/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup>): BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup(), model);
        BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup>): BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup.newInstance(<BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicOnpremResourceParserCleanup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
